import Interceptor from "./Interceptor";

/**
 * Get all plugins for a site
 */
export const getPlugins = async (siteId) => {
  try {
    const response = await Interceptor.get(`/plugins/sites/${siteId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Install a plugin
 */
export const installPlugin = async (siteId, plugin, activate = false) => {
  try {
    const response = await Interceptor.post(
      `/plugins/sites/${siteId}/install`,
      { plugin, activate },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Activate a plugin
 */
export const activatePlugin = async (siteId, plugin) => {
  try {
    const response = await Interceptor.post(
      `/plugins/sites/${siteId}/activate`,
      { plugin },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Deactivate a plugin
 */
export const deactivatePlugin = async (siteId, plugin) => {
  try {
    const response = await Interceptor.post(
      `/plugins/sites/${siteId}/deactivate`,
      { plugin },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete/uninstall a plugin
 */
export const deletePlugin = async (siteId, plugin) => {
  try {
    const response = await Interceptor.delete(`/plugins/sites/${siteId}`, {
      data: { plugin },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update a plugin
 */
export const updatePlugin = async (siteId, plugin) => {
  try {
    const response = await Interceptor.post(`/plugins/sites/${siteId}/update`, {
      plugin,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const PluginService = {
  getPlugins,
  installPlugin,
  activatePlugin,
  deactivatePlugin,
  deletePlugin,
  updatePlugin,
};

export default PluginService;
